const INITIAL_STATE = {
    registro: {},
    aguardando: false,
    modoTela: "lista",
    lista: [],
    listaCliente: [],
    listaUnidadeConsumidora: [],
    listaConcessionaria: [],
    listaMeses: [
        { id: "01", valor: "Janeiro" },
        { id: "02", valor: "Fevereiro" },
        { id: "03", valor: "Março" },
        { id: "04", valor: "Abril" },
        { id: "05", valor: "Maio" },
        { id: "06", valor: "Junho" },
        { id: "07", valor: "Julho" },
        { id: "08", valor: "Agosto" },
        { id: "09", valor: "Setembro" },
        { id: "10", valor: "Outubro" },
        { id: "11", valor: "Novembro" },
        { id: "12", valor: "Dezembro" },
    ],
    listaStatusImportacao: [
        { id: "TODAS", valor: "TODAS" },
        { id: "IMPORTADAS", valor: "IMPORTADAS" },
        { id: "NÃO IMPORTADAS", valor: "NÃO IMPORTADAS" },
    ],
    listaGraficoGeracaoSaldo: [],
    filtro: {
        ano: (() => {
            if (new Date().getMonth() == 0) {
                return new Date().getFullYear() - 1;
            } else {
                return new Date().getFullYear();
            }
        })(),
        mes: (() => {
            let data = new Date();
            data.setMonth(data.getMonth() - 1);

            return data.getMonth() < 9 ? `0${data.getMonth() + 1}` : data.getMonth() + 1;
        })(),
        id_cliente: null,
        id_concessionaria: null,
        unidades_consumidoras: [],
        id_grupo_faturamento: null,
        exibir_remotas: false,
        status_importacao: "IMPORTADAS",
    },
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "GESTAO_CREDITO_SOLAR_MODO_TELA":
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro,
            };

        case "GESTAO_CREDITO_SOLAR_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "GESTAO_CREDITO_SOLAR_FILTRO":
            return { ...state, filtro: action.payload };

        case "GESTAO_CREDITO_SOLAR_LISTADO":
            return {
                ...state,
                lista: action.payload,
            };

        case "GESTAO_CREDITO_SOLAR_GRAFICO_GERACAO_SALDO_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoSaldo: action.payload.data,
            };

        case "GESTAO_CREDITO_SOLAR_CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaCliente: action.payload.data,
            };

        case "GESTAO_CREDITO_SOLAR_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidora: action.payload.data,
            };

        case "GESTAO_CREDITO_SOLAR_CONCESSIONARIA_SELECT_LISTADO":
            return {
                ...state,
                listaConcessionaria: action.payload.data,
            };

        case "GESTAO_CREDITO_SOLAR_RESETAR_FILTRO":
            return {
                ...state,
                filtro: {
                    ano: (() => {
                        if (new Date().getMonth() == 0) {
                            return new Date().getFullYear() - 1;
                        } else {
                            return new Date().getFullYear();
                        }
                    })(),
                    mes: (() => {
                        let data = new Date();
                        data.setMonth(data.getMonth() - 1);

                        return data.getMonth() < 9 ? `0${data.getMonth() + 1}` : data.getMonth() + 1;
                    })(),
                    id_cliente: null,
                    id_concessionaria: null,
                    unidades_consumidoras: [],
                    id_grupo_faturamento: null,
                    exibir_remotas: false,
                    status_importacao: "TODAS",
                },
            };

        default:
            return state;
    }
};
